/**
 * Rende i blocchi del parser come nodi React. Nessun `innerHTML`: il testo del
 * modello e' testo, qualunque cosa contenga.
 */

import { Link } from "react-router-dom";
import { useAlberatura } from "../dati/contesto-alberatura";
import { analizzaMarkdown, type Inline } from "./analisi-markdown";
import { destinazioneCollegamento } from "./nodo-corrente";

function Inlines({ inline, idNodoCorrente }: { inline: Inline[]; idNodoCorrente: string | null }) {
  const { tuttiINodi } = useAlberatura();
  return (
    <>
      {inline.map((parte, i) => {
        if (parte.tipo === "acapo") return <br key={i} />;
        if (parte.tipo === "forte") return <strong key={i}>{parte.testo}</strong>;
        if (parte.tipo === "corsivo") return <em key={i}>{parte.testo}</em>;
        if (parte.tipo === "collegamento") {
          const destinazione = destinazioneCollegamento(parte.idNodo, tuttiINodi, idNodoCorrente);
          if (!destinazione) return <span key={i}>{parte.testo}</span>;
          return (
            <Link key={i} className="assistente__collegamento" to={destinazione}>
              {parte.testo}
            </Link>
          );
        }
        return <span key={i}>{parte.testo}</span>;
      })}
    </>
  );
}

export function Markdown({ testo, idNodoCorrente = null }: { testo: string; idNodoCorrente?: string | null }) {
  const blocchi = analizzaMarkdown(testo);
  return (
    <div className="assistente__markdown">
      {blocchi.map((blocco, i) => {
        if (blocco.tipo === "elenco") {
          return (
            <ul key={i}>
              {blocco.voci.map((voce, j) => (
                <li key={j}>
                  <Inlines inline={voce} idNodoCorrente={idNodoCorrente} />
                </li>
              ))}
            </ul>
          );
        }
        if (blocco.tipo === "riferimento") {
          return (
            <p key={i} className="assistente__riferimento">
              <span className="assistente__riferimento-etichetta">Riferimento</span> <Inlines inline={blocco.inline} idNodoCorrente={idNodoCorrente} />
            </p>
          );
        }
        return (
          <p key={i}>
            <Inlines inline={blocco.inline} idNodoCorrente={idNodoCorrente} />
          </p>
        );
      })}
    </div>
  );
}
